<bdg-autocomplete-field
  [provider]="municipioProvider"
  [control]="municipioForm"
  label="Município"
  (invalidEvent)="onMunicipioInvalid()"
  data-testid="municipio"
  idOption="municipio-option"
></bdg-autocomplete-field>
